import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiService } from '../../services/lsg.api.service';

export interface GlobalSearchResult {
  contacts: any[];
  products: any[];
  actions: any[];
}

@Injectable({
  providedIn: 'root',
})
export class GlobalSearchService {
  private historyKey = 'learmo_global_search_history';

  constructor(private api: ApiService) {}

  search(query: string): Observable<GlobalSearchResult> {
    return this.api.globalSearch(query).pipe(
      map((res: GlobalSearchResult) => {
        res.actions = this.searchActions(query);
        return res;
      })
    ) as Observable<GlobalSearchResult>;
  }

  private searchActions(query: string) {
    const actions = [
      {
        id: 'create-product',
        title: 'Create Product',
        type: 'action',
        link: '/dashboard/product/create',
      },
      {
        id: 'create-article',
        title: 'Create Article',
        type: 'action',
        link: '/dashboard/blog/create',
      },
    ];

    return actions.filter((action) =>
      action.title.toLowerCase().includes(query.toLowerCase())
    );
  }

  getHistory(): any[] {
    const history = localStorage.getItem(this.historyKey);
    return history ? JSON.parse(history) : [];
  }

  addToHistory(item: any, type: string) {
    const history = this.getHistory();
    // Avoid duplicates by ID or unique property
    const existingIndex = history.findIndex(
      (h) => h.id === item.id && h.type === type
    );
    if (existingIndex > -1) {
      history.splice(existingIndex, 1);
    }
    // Add to beginning
    history.unshift({ ...item, type, timestamp: new Date() });
    // Limit to 10
    if (history.length > 10) history.pop();

    localStorage.setItem(this.historyKey, JSON.stringify(history));
  }

  clearHistory() {
    localStorage.removeItem(this.historyKey);
  }
}
